import a from "./td-longtail-vue-components119.js";
/* empty css                              */
import l from "./td-longtail-vue-components98.js";
var n = function() {
  var s = this, t = s._self._c, e = s._self._setupProxy;
  return t("label", { staticClass: "toggle", class: e.containerClass }, [t("input", { staticClass: "toggle__checkbox", attrs: { role: "switch", type: "checkbox", tabindex: "0", "aria-label": s.ariaLabel }, domProps: { checked: s.value }, on: { change: e.change } }), t("span", { staticClass: "toggle__controls btn btn--default", class: e.controlsClasses }, [t("span", { staticClass: "toggle__bullet" })]), t("span", { staticClass: "toggle__label" }, [s._t("default", function() {
    return [t("span", { domProps: { innerHTML: s._s(s.label) } })];
  })], 2)]);
}, o = [], r = /* @__PURE__ */ l(
  a,
  n,
  o,
  !1,
  null,
  "e94d9e8d"
);
const g = r.exports;
export {
  g as default
};
